import React from "react";
import { Link } from "react-router-dom";
import HomeLayout from "../layouts/home";
import { useTranslation } from "../contexts/I18nProvider";

function NotFound() {
  const { t } = useTranslation();

  return (
    <HomeLayout className="flex flex-col items-center justify-center">
      {/* Title */}
      {/* Not Found */}
      <h2 className="text-4xl mt-24 text-accent-foreground mb-6 text-center">
        {t('pages.notFound.title')}
      </h2>

      {/* Error Message */}
      <p className="text-lg text-accent-foreground mb-8 text-center">
        {t('pages.notFound.message')}
      </p>

      {/* Buttons */}
      <div className="flex gap-4">
        <Link
          to="/"
          className="bg-indigo-600 text-white font-semibold py-2 px-6 rounded hover:bg-indigo-700 transition duration-200"
        >
          {t('pages.notFound.goHome')}
        </Link>
        <Link
          to="/contact"
          className="bg-accent text-accent-foreground font-semibold py-2 px-6 rounded hover:bg-accent transition duration-200"
        >
          {t('pages.notFound.contactSupport')}
        </Link>
      </div>

      {/* Illustration or Icon */}
      <div className="mt-12 h-[200px] w-[300px] bg-accent  rounded-tr-3xl rounded-bl-3xl rounded-lg overflow-hidden">
        <img
          src="https://picsum.photos/300/200"
          alt="404 Illustration"
          className="h-[200px] bg-accent"
        />
      </div>
    </HomeLayout>
  );
}

export default NotFound;
